<template>
  <div class="spec-select">
    <div v-for="(sectionItem, sectionIndex) in propsList" class="buy_item_container" :key="sectionIndex">
      <div class="buy_title">{{ sectionItem.standardListName }}</div>
      <div class="spec-value-container">
        <template v-for="(rowItem, rowIndex) in sectionItem.standardInfoList">
          <div
              :class="[
              'spec-value',
              rowItem.isSelect == 1 ? 'spec-value-s' : rowItem.isSelect == 0 ? 'spec-value-n' : 'spec-value-ns',
            ]"
              @click="itemClick(sectionItem, sectionIndex, rowIndex)"
              :key="rowIndex"
          >
            {{ rowItem.standardName }}
          </div>
        </template>
      </div>
    </div>
    <div class="buy_item_container">
      <div class="buy_title">
        <span>提货方式 Mode of delivery </span>
      </div>
      <div class="spec-value-container">
        <template v-for="(item, index) in pickWays">
          <div
              :class="['spec-value', item.isSelect == 1 ? 'spec-value-s' : 'spec-value-n']"
              @click="pickWayClick(index)"
              :key="index"
          >
            <span>{{ item.chName }} {{ item.enName }}</span>
          </div>
        </template>
      </div>
    </div>
    <div class="buy_item_container buy_item_container_b">
      <div class="buy_title">
        <span>数量 Quantity</span>
      </div>
      <el-input-number v-model="qty" :min="1" :max="999"></el-input-number>
    </div>
    <div v-if="isSale">
      <div class="add-to-cart" v-if="isBetween">
        <el-button type="primary" v-if="goodType == 0" size="default" @click="submitAction(2)"
        >加入购物车 Add to cart
        </el-button>
        <el-button type="primary" v-if="goodType == 4" size="default" @click="submitAction(0)"
        >积分兑换 Buy Now
        </el-button
        >
        <el-button type="primary" v-if="goodType == 1" size="default" @click="submitAction(1)"
        >立即秒杀 Immediately kill
        </el-button
        >
        <el-popover
            v-if="goodType == 2"
            title="微信扫码参与拼团 Scan the QR code to buy"
            width="350"
            trigger="hover"
        >
          <el-image :src="shareGroupImg"></el-image>
          <el-button slot="reference" type="primary" size="default">立即拼团 Buy Now</el-button>
        </el-popover>

      </div>
      <div v-else class="add-to-cart">
        <el-button disabled type="primary" size="default">非售卖时间 Non-selling hours</el-button>
      </div>
    </div>
    <div v-else class="add-to-cart">
      <el-button disabled type="primary" size="default">{{ saleStartTime }} 开售 Available</el-button>
    </div>
  </div>
</template>

<script>
import moment from "moment";

const {createDateSource, getObjKeys} = require("./config/sku.js");
export default {
  props: {
    isLogin: {
      type: Boolean,
      default: false,
    },
    hideTakeWay: {
      type: Boolean,
      default: false,
    },
    goodType: {
      type: [Number, String],
      default: 0,
    },
    detailInfo: {
      type: Object,
      default: () => {
      },
      observer(val) {
        console.log('detailInfo-observer-val======')
        let showPrice = "";
        if (this.properties.goodType == 4) {
          if (val.integralPrice - 0) {
            showPrice = "￥" + val.integralPrice + "+" + val.integralValue + "积分";
          } else {
            showPrice = val.integralValue + "积分";
          }
        } else {
          showPrice = "￥" + this.skuList[0].price;
        }
        this.setData({
          showPrice,
        });
        if (val.multiSpecSwitch == 0) {
          this.setData({
            count: val.skuList[0].stock,
          });
        }
        let pickWays = [];
        if (val.takeSelfSwitch == 1) {
          pickWays.push({
            value: "0",
            chName: "自提",
            enName: "Self Pickup",
            isSelect: 1,
          });
        }
        //民族不展示物流配送
        if (val.takeLogisticsInTimeSwitch == 1 || val.takeLogisticsHomeSwitch == 1) {
          pickWays.push({
            value: "1",
            chName: "物流配送",
            enName: "Logistics and distribution",
            isSelect: 0,
          });
        }
        this.setData({
          pickWays,
          saleStartTime: val.saleStartTime,
        });
        //开售时间开关，默认0不置开售时间，1开售时间
        const saleStartSwitch = val.saleStartSwitch
        //(是否在开售时间内，默认0不在开售时段内，1在开售时段内)
        const saleAllow = val.saleAllow
        // console.log('saleStartSwitch', saleStartSwitch, 'saleAllow', saleAllow)
        if (saleStartSwitch == 1) {
          this.setData({
            isSale: false
          })
        } else {
          this.setData({
            isSale: true
          })
        }
      },
    },
    skuList: {
      type: Array,
      observer(val) {
      },
    },
    //'buy'  'basket', 'activityBuy'
    tapType: {
      type: String,
      default: "",
    },
    //属性列表
    propsList: {
      type: Array,
      default: () => [],
    },
    skuData: {
      type: Object,
      default: () => {
      },
    }, //sku数据
    shareVisitCode: {
      type: String,
      default: "",
    },
    //拼团分享图片
    shareGroupImg: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isSale: true,//是否在开售时间内
      isBetween: true,//是否在开售时段
      saleStartTime: '',//开售时间
      skuResult: [], //处理好的排列组合方式
      selectedValueArray: [], //存放选中属性名的数组
      initialPrice: "", //初始价格
      showPrice: "", //显示价格
      showSpecspan: "", //显示规格
      goodsId: "", //商品id
      count: 0, //库存数
      qty: 1, //选中的商品数量
      takeWay: "0", //默认为0， 自提 1 为物流配送
      pickWays: [],
    };
  },
  mounted() {
  },
  computed: {
    show() {

    }
  },
  components: {},
  /**
   * 组件的方法列表
   */
  methods: {
    init() {
      var skuData = this.skuData;
      var skuResult = createDateSource(skuData);
      this.skuResult = skuResult;
      this.reloadDataSource();
    },
    //显示弹窗
    showModal: function () {
      var specwindow = this.selectComponent("#modal");
      specwindow.showModal();
    },
    ///隐藏弹窗
    hideModal: function () {
      var specwindow = this.selectComponent("#modal");
      specwindow.hideModal();
    },
    ///处理初始页面的展示数据 可选 选中 不可选
    reloadDataSource: function () {
      var {skuResult, propsList, selectedValueArray, showPrice, count} = this;
      var skuKeys = getObjKeys(skuResult);

      ///取出sku所有组合的价格 取出最大值和最小值 获得价格区间
      var allPrice = [];

      skuKeys.forEach((item) => {
        var skuData = skuResult[item];
        var prices = skuData["prices"];
        count = count + skuData["stocksNumber"];
        allPrice = allPrice.concat(prices);
      });
      // ///取出最大值和最小值 这就是初始价格
      // var maxPrice = Math.max.apply(Math, allPrice);
      // var minPrice = Math.min.apply(Math, allPrice);

      // showPrice = maxPrice == minPrice ? `￥${minPrice}` : `￥${minPrice}~￥${maxPrice}`;
      // console.log(propsList, this.propsList);
      if (this.propsList.length == 0) {
        return;
      }
      ///遍历属性列表
      propsList.forEach((item, i) => {
        var standardInfoList = item.standardInfoList;
        var x = -1;
        var standardName = "";
        ///遍历各种规格的值的列表
        for (var j = 0; j < standardInfoList.count; j++) {
          var dict = standardInfoList[j];
          var isSelected = dict.isSelected;
          var StandardName = dict.standardName;
          ///如果有选中的就跳出该循环
          if (isSelected == 1) {
            x = j;
            standardName = StandardName;
            break;
          }
        }
        //如果x = -1表示当前没有选中的 添加默认值
        if (x == -1) {
          selectedValueArray.push("");
        } else {
          //表示有选中的 把选中id添加到数组中
          selectedValueArray.push(standardName);
        }
      });
      this.selectedValueArray = selectedValueArray;
      this.count = count;
      this.handDisEnableData();
      this.handSpecifications();
    },
    ///处理不可选的数据
    handDisEnableData: function () {
      var {skuResult, propsList, selectedValueArray} = this;
      var skuKeys = getObjKeys(skuResult);
      console.log(skuKeys);
      ///遍历属性列表
      propsList.forEach((item, i) => {
        var standardInfoList = item.standardInfoList;
        standardInfoList.forEach((item2) => {
          var standardName = item2.standardName;
          ///将selectedValueArray赋值给一个临时数组 这个地方需要解构 不然会有问题
          var tempArray = [...selectedValueArray];
          ///从已经选好的组合中 移除当前组之前的id 并插入新的id
          tempArray.splice(i, 1, standardName);
          ///移除没有选中的组 即 '' 空字符串
          var next = true;
          while (next) {
            var index = tempArray.indexOf("");
            if (index == -1) {
              next = false;
            } else {
              tempArray.splice(index, 1);
            }
          }
          ///将处理完的组合排序
          tempArray.sort(function (value1, value2) {
            // return parseInt(value1) - parseInt(value2);
            return value1.localeCompare(value2, "zh-CN");
          });
          ///排序之后进行拼接
          var resultKey = tempArray.join(";");
          ///如果找不到当前的组合 表示当前属性不可选 则改变属性列表中isSelect的值
          var index = skuKeys.indexOf(resultKey);
          if (index == -1) {
            item2.isSelect = -1;
          } else {
            ///如果之前是不可选的 然而后续可选  就将isSelect换为0
            if (item2.isSelect == -1) {
              item2.isSelect = 0;
            }
          }
        });
      });
      this.propsList = propsList;
    },
    ///计算价格 库存 已经获取商品id
    calculatePrice: function () {
      var {
        skuResult,
        selectedValueArray,
        // initialPrice,
        showPrice,
        goodsId,
        count,
      } = this;
      var skuKeys = getObjKeys(skuResult);
      var tempArray = [...selectedValueArray];
      ///移除没有选中的组 即 '' 空字符串
      var next = true;
      while (next) {
        var index = tempArray.indexOf("");
        if (index == -1) {
          next = false;
        } else {
          tempArray.splice(index, 1);
        }
      }
      ///将处理完的组合排序
      tempArray.sort(function (value1, value2) {
        // return parseInt(value1) - parseInt(value2);
        return value1.localeCompare(value2, "zh-CN");
      });
      ///排序之后进行拼接
      var resultKey = tempArray.join(";");
      console.log(resultKey, skuKeys);
      var index = skuKeys.indexOf(resultKey);
      ///重置 在全部取消选中时需要还原
      // showPrice = initialPrice;
      goodsId = "";
      count = 0;
      ///表示匹配到了
      if (index != -1) {
        var skuData = skuResult[resultKey];
        // var prices = skuData['prices'];
        //取出最大值和最小值
        // var maxPrice = Math.max.apply(Math, prices);
        // var minPrice = Math.min.apply(Math, prices);
        // showPrice = maxPrice == minPrice ? `￥${minPrice}` : `￥${minPrice}~￥${maxPrice}`;

        if (tempArray.length == this.propsList.length) {
          ///当所有属性全部选中时 只会有一个id 所以 取第一个就可以了
          var productIds = skuData["productIds"];
          goodsId = productIds[0];
          count = skuData["stocksNumber"];
          let showPrice = `￥${skuData["prices"][0]}`;
          //积分显示钱+积分
          if (this.goodType == 4) {
            if (skuData["integralPrice"][0] - 0) {
              showPrice = `￥${skuData["integralPrice"][0]}+${skuData["integralValue"][0]}积分`;
            } else {
              showPrice = `${skuData["integralValue"][0]}积分`;
            }
          }
          console.log(skuData, productIds, showPrice);
          this.showPrice = showPrice;
        }
      }
      this.goodsId = goodsId;
      this.count = count;
      this.$emit("postShowPrice", showPrice);
    },
    ///处理规格
    handSpecifications: function () {
      var {selectedValueArray} = this;
      var tempArray = [...selectedValueArray];
      ///移除没有选中的组 即 '' 空字符串
      var next = true;
      while (next) {
        var index = tempArray.indexOf("");
        if (index == -1) {
          next = false;
        } else {
          tempArray.splice(index, 1);
        }
      }
      var showSpecspan = tempArray.join(",");
      this.showSpecspan = showSpecspan;
    },

    //属性点击事件
    itemClick: function (sectionItem, sectionIndex, rowIndex) {
      var {propsList, selectedValueArray, selectedValueArray} = this;
      ///取到当前点击的组
      var sectionItem = propsList[sectionIndex].standardInfoList;
      ///取到当前点击的行
      var rowItem = sectionItem[rowIndex];
      var isSelect = rowItem.isSelect;
      ///表示不可选 直接return
      if (isSelect == -1) {
        return;
      }
      ///可选 替换原本的id 插入新的id
      if (isSelect == 0) {
        var standardName = rowItem.standardName;
        selectedValueArray.splice(sectionIndex, 1, standardName);
        ///遍历当前组 如果已经有选中的 则去掉之前的选中
        sectionItem.forEach((item) => {
          if (item.isSelect == 1) {
            item.isSelect = 0;
          }
        });
      }
      ///选中  取消选中
      else {
        selectedValueArray.splice(sectionIndex, 1, "");
      }
      rowItem.isSelect = isSelect == 1 ? 0 : 1;
      this.propsList = propsList;
      this.selectedValueArray = selectedValueArray;
      this.handDisEnableData();
      this.calculatePrice();
      this.handSpecifications();
    },
    changeCount: function (e) {
      console.log(this.count, e.detail.buyCount);
      if (this.count - 0 < e.detail.buyCount - 0) {
        // wx.showToast({
        //   title: "数量超出范围",
        //   icon: "none",
        // });
        this.qty = this.count;
      } else {
        this.qty = e.detail.buyCount;
      }
    },

    onClose: function (e) {
      this.triggerEvent("close");
    },

    pickWayClick(index) {
      let pickWays = [...this.pickWays];
      pickWays = pickWays.map((item, idx) => {
        if (idx == index) {
          item.isSelect = 1;
        } else {
          item.isSelect = 0;
        }
        return item;
      });
      this.pickWays = pickWays;
      this.takeWay = pickWays[index].value;
    },

    //提交
    submitAction: function (type) {
      //  type: 0 积分兑换 1 秒杀 2 加购
      if (this.detailInfo.multiSpecSwitch == 0) {
        this.goodsId = this.skuList[0].id;
      }
      var {goodsId, skuData, qty, takeWay} = {
        ...this,
      };
      if (goodsId == "") {
        this.$message.warning("请选择 规格");
        return false;
      }
      if (this.count - 0 < this.qty - 0) {
        this.$message.warning("数量超出范围");
        return false;
      }
      let checkedGood = {
        skuId: goodsId,
        qty: qty,
      };
      if (type == 1) {
        checkedGood.activityId = this.goodType == 1 || this.goodType == 2 ? this.detailInfo.id : undefined;
      }
      this.$emit("submitAction", {
        type: type,
        takeWay: takeWay,
        checkedGood,
      });
    },
    //是否在开售时段
    isSaleFn(val) {
      const saleTimeSlotList = val.saleTimeSlotList
      for (let i = 0; i < saleTimeSlotList.length; i++) {
        let item = saleTimeSlotList[i]
        //当前年月日
        let currentDate = moment().format('YYYY-MM-DD');
        //开始时间
        let saleBeginTime = item.saleBeginTime.split('')
        saleBeginTime.splice(2, 0, ':')
        let beginDate = moment(`${currentDate} ${saleBeginTime.join('')}`).subtract(1,'m')
        //结束时间
        let saleEndTime = item.saleEndTime.split('')
        saleEndTime.splice(2, 0, ':')
        let edDate = moment(`${currentDate} ${saleEndTime.join('')}`).add(1,'m')
        const currentTime=moment().format('YYYY-MM-DD HH:mm')
        let isBetween = moment(currentTime).isBetween(beginDate, edDate);
        if (isBetween) {
          return true
        }
      }
      return false;
    },
  },
  watch: {
    skuData: {
      handler(val) {
        this.init();
      },
      deep: true,
    },
    detailInfo: {
      handler(val) {
        let showPrice = "";
        if (this.goodType == 4) {
          if (val.integralPrice - 0) {
            showPrice = "￥" + val.integralPrice + "+" + val.integralValue + "积分";
          } else {
            showPrice = val.integralValue + "积分";
          }
        } else {
          showPrice = "￥" + this.skuList[0].price;
        }
        this.showPrice = showPrice;
        if (val.multiSpecSwitch == 0) {
          this.count = val.skuList[0].stock;
        }
        let pickWays = [];
        if (val.takeSelfSwitch == 1) {
          pickWays.push({
            value: "0",
            chName: "自提",
            enName: "Self Pickup",
            isSelect: 1,
          });
        }
        //民族不展示物流配送
        if (val.takeLogisticsInTimeSwitch == 1 || val.takeLogisticsHomeSwitch == 1) {
          pickWays.push({
            value: "1",
            chName: "物流配送",
            enName: "Logistics and distribution",
            isSelect: 0,
          });
        }
        this.pickWays = pickWays;
        this.saleStartTime = val.saleStartTime
        //开售时间开关，默认0不置开售时间，1开售时间
        const saleStartSwitch = val.saleStartSwitch
        //(是否在开售时间内，默认0不在开售时段内，1在开售时段内)
        const saleAllow = val.saleAllow
        if (saleStartSwitch == 1) {
          this.isSale = saleAllow == 1
        } else {
          this.isSale = true
        }
        if (val.gtype == 1) {
          this.isBetween = this.isSaleFn(val);
        }

      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.spec-select {
  .buy_item_container {
    margin-top: 39px;
    font-size: 14px;

    .buy_title {
      color: #333333;
      margin-bottom: 20px;
    }

    .spec-value-container {
      display: flex;
      flex-flow: wrap;
      flex-direction: row;

      .spec-value {
        margin-right: 20px;
        cursor: pointer;
        padding: 14px;
      }

      .spec-value-s {
        background: #333333;
        color: #ffffff;
        border: 1px solid #333333;
      }

      .spec-value-n {
        background: #ffffff;
        border: 1px solid #333333;
        color: #333333;
      }

      .spec-value-ns {
        background: #ffffff;
        border: 1px solid #cccccc;
        color: #999999;
        padding: 14px;
      }
    }
  }

  /deep/ .el-input-number__decrease {
    width: 40px;
    height: 40px;
    background: #333333;
    color: #fff;
    box-sizing: border-box;
  }

  /deep/ .el-input-number__increase {
    width: 40px;
    height: 40px;
    background: #333333;
    color: #fff;
    box-sizing: border-box;
  }

  .add-to-cart {
    margin-top: 40px;

    /deep/ .el-button {
      width: 426px;
      height: 60px;
      box-sizing: border-box;
      font-size: 18px;
    }
  }
}
</style>
